import { UserInteface } from '../../models/state';
import { actionTypes } from '../actions/auth';

const initialState = {
  user: {} as UserInteface,
};
const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_USER_SUCCESS: {
      return {
        ...state,
        user: { ...action.payload, isAdmin: action.payload.role === 'Admin' },
      };
    }
    case actionTypes.LOGIN_USER_SUCCESS: {
      return {
        ...state,
        user: { ...action.payload, isAdmin: action.payload.role === 'Admin' },
      };
    }
    case actionTypes.GET_USER_WITH_CODE_SUCCESS: {
      return {
        ...state,
        user: { ...action.payload, isAdmin: action.payload.role === 'Admin' },
      };
    }
    default: {
      return state;
    }
  }
};

export default userReducer;
